document.addEventListener("DOMContentLoaded", function() {
  preventScrollOnNumberInputs();
});

function preventScrollOnNumberInputs() {
  const inputs = document.querySelectorAll("input[type=number]");

  inputs.forEach(function(input) {
    input.addEventListener("wheel", function() {
      input.blur();
    });
  });
}
